var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#F0F9E8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.9278 5.0722C4.49388 5.50612 4.49388 6.20964 4.9278 6.64355L10.1421 11.8579L4.78566 17.2143C4.35174 17.6482 4.35174 18.3517 4.78566 18.7857C5.21957 19.2196 5.92309 19.2196 6.35701 18.7857L11.7135 13.4292L17.4986 19.2143C17.9325 19.6483 18.636 19.6483 19.0699 19.2143C19.5038 18.7804 19.5038 18.0769 19.0699 17.643L13.2848 11.8579L18.9278 6.21487C19.3617 5.78096 19.3617 5.07744 18.9278 4.64352C18.4939 4.20961 17.7904 4.20961 17.3564 4.64352L11.7135 10.2865L6.49914 5.0722C6.06523 4.63829 5.36171 4.63829 4.9278 5.0722Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.8252c125fda57e389b1966312176a3ed.svg";
export { ForwardRef as ReactComponent };